import {emailValidator} from '@packages/shared/utils/Emails';
import {isEmpty} from 'lodash';

export function validateReplyToTokens(
  token: string,
  knownTokens: {label: string; value: string; type: string}[]
):
  | {isValid: true; errorMessage?: string}
  | {isValid: false; errorMessage: string} {
  const errorMessage = `${token.trim()} is not a valid email destination.`;

  // Match name token and email token: '{{ name }} < {{ email }} >'
  const doubleTokenEntryMatch = token.match(
    /^\{\{\s*(.+?)\s*\}\}\s*<\s*\{\{\s*(.+?)\s*\}\}\s>$/
  );
  if (doubleTokenEntryMatch) {
    const [_, nameToken, emailToken] = doubleTokenEntryMatch;
    return {
      isValid:
        knownTokens.some(
          (knownToken) =>
            knownToken.label === nameToken && knownToken.type === 'text'
        ) &&
        knownTokens.some(
          (knownToken) =>
            knownToken.label === emailToken && knownToken.type === 'email'
        ),
      errorMessage,
    };
  }

  // Match manual name and email token format: 'name < {{ email }} >'
  const hybridTokenMatch = token.match(
    /^\s*(.+?)\s*<\s*\{\{\s*(.+?)\s*\}\}\s>$/
  );
  if (hybridTokenMatch) {
    const [_, _name, emailToken] = hybridTokenMatch;
    return {
      isValid: knownTokens.some(
        (knownToken) =>
          knownToken.label === emailToken && knownToken.type === 'email'
      ),
      errorMessage,
    };
  }

  // Match email-only format: '< {{ email }} >'
  const emailTokenOnlyMatch = token.match(/^<\s*\{\{\s*(.+?)\s*\}\}\s>$/);
  if (emailTokenOnlyMatch) {
    const [_, emailToken] = emailTokenOnlyMatch;
    return {
      isValid: knownTokens.some(
        (knownToken) =>
          knownToken.label === emailToken && knownToken.type === 'email'
      ),
      errorMessage,
    };
  }

  // Match manual name and email as strings format: 'name <email@gmail.com>'
  const stringTokensMatch = token.match(/^\s*(.+?)\s*<\s*(.+?)\s*>$/);
  if (stringTokensMatch) {
    const [_, _name, emailToken] = stringTokensMatch;
    return {
      isValid: Boolean(
        emailToken &&
        emailValidator({email: emailToken.trim()})?.email === undefined
      ),
      errorMessage,
    };
  }

  // Right now there's no required field so we don't need to return the error type
  const errors = emailValidator({email: token.trim()});
  if (token && !isEmpty(errors)) {
    return {
      isValid: false,
      errorMessage,
    };
  }

  return {
    isValid: true,
  };
}
